import { HonestState } from "../components.js";
import type { DateScenarioView, Metric, ScopeAtDateValue } from "../api/scenarioService.js";

function ScopeResult({
  label,
  metric,
}: {
  label: string;
  metric: Metric<ScopeAtDateValue>;
}): React.ReactNode {
  if (metric.kind === "n/a") {
    return <HonestState kind="nodata" detail={`${label}: ${metric.reason}`} />;
  }
  const value = metric.value;
  return (
    <div className="ribbon" data-testid={`scope-${label.toLowerCase()}`}>
      <strong>
        {label} · {value.targetDate.slice(0, 10)}
      </strong>
      <div className="date">
        <span className="num">{value.scopeAtP50}</span>
        <small>items expected · p50</small>
      </div>
      <div className="meta">
        At least {value.scopeAtP85} items at 85% confidence · {value.remainingItems} in plan
      </div>
      <div>Item-level risk is unavailable: no backlog order has been declared.</div>
      <small>
        Model: {value.modelVersion} · confidence:{" "}
        {metric.confidence.kind === "value" ? metric.confidence.confidence : "N/A"} · evidence:{" "}
        {metric.lineage.join(", ") || "none"}
      </small>
    </div>
  );
}

export function DateScopeComparison({ result }: { result: DateScenarioView }): React.ReactNode {
  return (
    <div className="scope-comparison" data-testid="date-scope-comparison">
      <ScopeResult label="Before" metric={result.baseline.forecast} />
      <ScopeResult label="After" metric={result.scenario.forecast} />
    </div>
  );
}
